/* eslint-disable @typescript-eslint/no-explicit-any */
import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { headlessDeliveryApi as API } from '../Apis';

export const HeadlessDeliveryDocs: IDocs = {
  title: 'Headless Delivery',
  description: 'Essa funcionalidade busca conteúdos disponíveis no CMS Liferay',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.findHeadlessDelivery',
};

const prepareCall = (stateRequestParameters: any) => {
  const friendlyUrlPath = 'friendlyUrlPath';
  if (
    stateRequestParameters?.fields &&
    !stateRequestParameters?.fields?.includes(friendlyUrlPath)
  ) {
    stateRequestParameters?.fields?.push(friendlyUrlPath);
  }

  return API.call.get({
    flatter: stateRequestParameters.flatter,
    filter: stateRequestParameters.filter,
    fields: stateRequestParameters?.fields,
  });
};

const handleSucessFinalResponseFunction = (data: any) => {
  const { items } = data.data || data;

  const finalData: any = items.map(
    (itemKey: { friendlyUrlPath: string; contentFields: any[] }) => {
      const response = {
        key: itemKey.friendlyUrlPath,
        contentFields: itemKey.contentFields,
      };

      return response;
    },
  );

  return finalData;
};

export const HeadlessDeliveryMachine = GenericMachine(
  prepareCall,
  {
    docs: HeadlessDeliveryDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
  },
);
